// @mui
import { Box, Typography } from '@mui/material';

const FONT_MERRIWEATHER = '"Merriweather",serif';

const imageStyle = () => {
  return {
    height: { xs: 250, md: 390 },
    background: `linear-gradient(0deg, rgba(0,0,0, 0.5), rgba(0,0,0, 0.5)),url('/images/banner/newBannerPhoto.jpg')`,
    boxShadow: 1,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };
};

export default function PageHeader() {

  return (
    <Box sx={imageStyle}>
      <Typography sx={{ typography: 'h2', color: '#ffffff', fontFamily: `${FONT_MERRIWEATHER} !important` }}>
        Explore Projects
      </Typography>
    </Box>
  );
}
